import { requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const getJobResult = (jobId, user) => {
  return requestWithPromise(
    `/job-result/${jobId}`,
    HttpMethods.GET,
    null,
    user,
    true
  )
}

export const getJob = (jobId, user) => apiClient.get(user, `job-result/${jobId}`)
